'use client';

export default function PlayerCF({
  token,
  customerCode,
  poster,
}: {
  token: string,
  customerCode?: string,
  poster?: string,
}) {
  const base = `https://customer-${customerCode}.cloudflarestream.com/${token}/iframe`;
  const src = poster ? `${base}?poster=${encodeURIComponent(poster)}` : base;

  return (
    <iframe
      src={src}
      allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
      allowFullScreen
      style={{ width: `100%`, height: `100%`, border: `none`, }}
    />
  );
}
